import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { formatWithSign } from '@features/executive-report/utils/format-with-sign';
import { formatters } from '@utils/formattersV2';

type MetricOptions = {
  label: string;
  formatter: (visitMetrics: Lci3Report['visitMetrics']) => string;
};

export const pyramidMetrics = [
  {
    label: 'Incremental Visits',
    formatter: visitMetrics =>
      `${formatters.visits(visitMetrics.incrementalVisits, { full: true })} (${formatters.lift(visitMetrics.incrementalLift, { decimals: 1 })} Lift)`,
  },
  {
    label: 'Total Projected Visits',
    formatter: visitMetrics =>
      formatters.visits(visitMetrics.projectedVisits, { full: true }),
  },
  {
    label: 'Unique Users Reached',
    formatter: visitMetrics =>
      formatters.users(visitMetrics.uniqueUsers, { full: true }),
  },
  {
    label: 'Total Impressions',
    formatter: visitMetrics =>
      formatters.impressions(visitMetrics.impressions, { full: true }),
  },
] as const satisfies readonly MetricOptions[];

export const topLevelMetrics = [
  {
    label: ['<b>', 'Incremental Visit Lift %'.toUpperCase(), '</b>'].join(''),
    formatter: visitMetrics =>
      formatWithSign(visitMetrics.incrementalLift, value =>
        formatters.lift(value, { decimals: 1 })
      ),
  },
  {
    label: [
      'Total '.toUpperCase(),
      '<b>',
      'Incremental Visits'.toUpperCase(),
      '</b>',
    ].join(''),
    formatter: visitMetrics =>
      formatters.visits(visitMetrics.incrementalVisits, { full: true }),
  },
] as const satisfies readonly MetricOptions[];
